import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * PaymentMethodCard do DS (ORCA-1929): uma forma de pagamento no editor.
 * Switch para oferecer, ícone, nome, resumo, preço em destaque e botão para abrir as configurações
 * (conteúdo projetado). Desligada: "Não oferecido" e sem botão de abrir.
 */
@Component({
    selector: 'oa-payment-method-card',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="oa-pm" [class.oa-pm--on]="on" [class.oa-pm--compact]="compact">
            <div class="oa-pm__head">
                <oa-switch [checked]="on" [label]="'Oferecer ' + name" [disabled]="disabled" (checkedChange)="onToggle($event)"></oa-switch>
                <span class="oa-pm__icon" aria-hidden="true"><mat-icon>{{ icon }}</mat-icon></span>
                <span class="oa-pm__text">
                    <b><mat-icon *ngIf="compact" class="oa-pm__inline-icon" aria-hidden="true">{{ icon }}</mat-icon>{{ name }}</b>
                    <span>{{ on ? summary : offLabel }}</span>
                </span>
                <span class="oa-pm__headline">{{ on ? headline : '' }}</span>
                <button *ngIf="on && expandable" type="button" class="oa-icon-btn oa-icon-btn--sm"
                    [attr.aria-expanded]="open ? 'true' : 'false'"
                    [attr.aria-label]="(open ? 'Fechar ' : 'Configurar ') + name" (click)="setOpen(!open)">
                    <mat-icon>{{ open ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
            </div>
            <div class="oa-pm__body" *ngIf="on && open"><ng-content></ng-content></div>
        </div>
    `,
    styles: [':host { display: block; }'],
})
export class OaPaymentMethodCardComponent {
    @Input() name = '';
    @Input() icon = 'payments';
    @Input() summary = '';
    @Input() headline = '';
    @Input() offLabel = 'Não oferecido';
    @Input() on = false;
    @Input() open = false;
    @Input() expandable = true;
    @Input() disabled = false;
    /** Coluna estreita: o ícone vai junto do nome e o preço em destaque some */
    @Input() compact = false;
    @Output() toggle = new EventEmitter<boolean>();
    @Output() expand = new EventEmitter<boolean>();

    onToggle(on: boolean) {
        this.on = on;
        this.toggle.emit(on);
        this.setOpen(on);
    }

    setOpen(open: boolean) {
        this.open = open;
        this.expand.emit(open);
    }
}
